import FeatureFlags from '../../../../libs/essentials/types/src/feature-flags';

export const featureFlags: { featureFlags: FeatureFlags } = {
  featureFlags: {
    setsAppContext: false,
    enableBrowserBackOnCustomModalClosing: false,
    indicateSelfTyping: false,
    isNativeApp: false,
    messageTextMaxLength: 1000,
    saveNotificationSettingsInStorage: false,
  },
};
